module.exports = __webpack_public_path__ + "static/img/avatar2.08803b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/avatar2.png
// module id = Go8g
// module chunks = 20